import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceMain {
    lookupService = new APIServiceLookUp();

    async getMain(body, orgid) {
        var serviceType = "CUST";
        var url = `${API_URL}idp/getMain`;
        var apiService = this.lookupService.getAPIService(serviceType);
        var requestHeaders = {
            'Content-type': 'application/json',
            'Accept': 'application/json',
            'x-org-id': orgid,
        };
        return await apiService.doCall(url, body, requestHeaders);
    }
}